import React, { useContext } from 'react';
import Dropzone from 'react-dropzone';
import classes from '../Form.module.scss';
import { GeneralContext } from '../../../context/generalContext';

export default function FormInputFile(props) {
  const { activeLanguage } = useContext(GeneralContext);
  const removeUserFile = () => props.setUserFile([]);

  // конвертируем байты в кб и мб
  function convertBytesToSize(bytes, decimals = 2) {
    if (bytes === 0) return '0 байт';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['байт', 'кб', 'мб'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / k ** i).toFixed(dm)).toLocaleString()} ${sizes[i]}`;
  }

  let accept;
  let dropzoneReq = '';
  if (props.type === 'photo') {
    accept = {
      'image/jpg': ['.jpg'],
      'image/jpeg': ['.jpeg'],
      'image/png': ['.png'],
    };
    dropzoneReq = '.JPG, .PNG';
  } else if (props.type === 'doc') {
    accept = {
      'application/msword': ['.doc', '.docx'],
      'application/pdf': ['.pdf'],
    };
    dropzoneReq = '.DOC, .PDF';
  }

  const toBase64 = file =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });

  return (
    <>
      <Dropzone
        {...props.register}
        onDrop={(acceptedFiles, fileRejections) => {
          props.setUserFile(
            acceptedFiles.map(file =>
              Object.assign(file, {
                preview: URL.createObjectURL(file),
                base64: toBase64(file),
              }),
            ),
          );
          fileRejections.forEach(file => {
            file.errors.forEach(err => {
              if (err.code === 'file-too-large') {
                props.setUserFileError('Файл слишком большой');
              }
            });
          });
          fileRejections.length === 0 && props.setUserFileError('');
        }}
        multiple={false}
        maxSize={5242880}
        accept={accept}
      >
        {({ acceptedFiles, getRootProps, getInputProps }) => (
          <div className={classes.dropzoneWrap}>
            <div
              {...getRootProps({ className: classes.dropzone })}
              data-has-error={props.userFileError.length > 0 ? 'true' : 'false'}
            >
              <input {...getInputProps()} />
              <div className={classes.dropzoneLabel}>{props.label}</div>
              <div className={classes.dropzoneReq}>
                {dropzoneReq}
                {activeLanguage === 1 ? ' до 5 Мб' : ' no more than 5Mb'}
              </div>
            </div>
            {props.userFile.length > 0 && (
              <div className={classes.dropzoneResult}>
                <div className={classes.dropzoneSmall}>{props.label}</div>
                <div className={classes.dropzoneFiles}>
                  {acceptedFiles.map(file => (
                    <div className={classes.dropzoneFile} key={file.path}>
                      <div className={classes.dropzoneFileName}>{file.path}</div>
                      <div className={classes.dropzoneFileSize}>{convertBytesToSize(file.size)}</div>
                    </div>
                  ))}
                </div>
                <button className={classes.dropzoneRemoveBtn} type='button' onClick={removeUserFile} />
              </div>
            )}
          </div>
        )}
      </Dropzone>
      <div className={classes.inputError}>{props.userFileError.length > 0 && props.userFileError}</div>
    </>
  );
}
